const esFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'EUR',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { esFormats };
